"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethodMap = void 0;
exports.paymentMethodMap = {
    creditCard: 'creditCard',
    bankTransfer: 'sepa',
    invoice: 'invoice',
    sepa: 'sepa',
    paypal: 'braintree',
};
const billing = (sdk) => {
    const { sdkConfig: { url }, defaultVersion, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        cancelSubscription: async (userId, cancelOptions) => {
            const endpoint = `${url}/${defaultVersion}/billings/${userId}/cancelSubscription`;
            await httpClient.put(endpoint, { payload: cancelOptions });
        },
        cancelStripeSubscription: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/billings/cancel-subscription`;
            const response = await httpClient.post(endpoint, { payload });
            return response.data;
        },
        getSubscription: async (userId) => {
            const endpoint = `${url}/${defaultVersion}/billings/${userId}/subscription`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        getSubscriptionDetails: async () => {
            const endpoint = `${url}/${defaultVersion}/billings/subscription-details`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        getInvoices: async (userId) => {
            const endpoint = `${url}/${defaultVersion}/billings/${userId}/invoices`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        getInvoiceDownloadLink: async (userId, invoiceId) => {
            const endpoint = `${url}/${defaultVersion}/billings/${userId}/invoices/${invoiceId}`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        getSignature: async (method, source) => {
            const endpoint = `${url}/${defaultVersion}/billings/signature/zuora`;
            const query = { method };
            if (source) {
                query.source = source;
            }
            const response = await httpClient.get(endpoint, { query, credentials: 'include' });
            return response.data;
        },
        getBraintreeSignature: async () => {
            const endpoint = `${url}/${defaultVersion}/billings/signature/braintree`;
            const response = await httpClient.get(endpoint, { credentials: 'include' });
            return response.data;
        },
        getLicenceById: async (licenceModelId) => {
            const endpoint = `${url}/${defaultVersion}/billings/licence/${licenceModelId}`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        getPaymentMethod: async (userId) => {
            const endpoint = `${url}/${defaultVersion}/billings/${userId}/paymentMethod`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        updatePaymentMethod: async (userId, method) => {
            const endpoint = `${url}/${defaultVersion}/billings/${userId}/paymentMethod`;
            const response = await httpClient.put(endpoint, { payload: method });
            return response.data;
        },
        updatePaymentPeriod: async (userId, paymentPeriod) => {
            const endpoint = `${url}/${defaultVersion}/billings/${userId}/paymentPeriod`;
            const payload = { paymentPeriod };
            await httpClient.put(endpoint, { payload });
        },
        getDiscountInformation: async (promoCode, licenceId) => {
            const endpoint = `${url}/${defaultVersion}/billings/promoCode/${promoCode}/discountInformation/${licenceId}`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        getActiveLicences: async () => {
            const endpoint = `${url}/${defaultVersion}/billings/licence`;
            const response = await httpClient.get(endpoint, { credentials: 'include' });
            return response.data;
        },
        addTrialDiscount: async (userId) => {
            const endpoint = `${url}/${defaultVersion}/billings/${userId}/addTrialDiscount`;
            await httpClient.post(endpoint);
        },
        createPortalSession: async (returnUrl) => {
            const endpoint = `${url}/${defaultVersion}/billings/portal-session`;
            const response = await httpClient.post(endpoint, {
                payload: { returnUrl },
            });
            return response.data;
        },
        createCheckoutSession: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/billings/checkout-session`;
            const response = await httpClient.post(endpoint, { auth: false, payload });
            return response.data;
        },
        // SM-284. Anonymous (no account yet); API replies 204, nothing to return.
        updateCheckoutSession: async (sessionId, payload) => {
            const endpoint = `${url}/${defaultVersion}/billings/checkout-session/${sessionId}`;
            await httpClient.put(endpoint, { auth: false, payload });
        },
        getCheckoutStatus: async (sessionId) => {
            const endpoint = `${url}/${defaultVersion}/billings/checkout-session/${sessionId}/status`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        checkEmail: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/billings/check-email`;
            const response = await httpClient.post(endpoint, { auth: false, payload });
            return response.data;
        },
        getUpgradeOptions: async () => {
            const endpoint = `${url}/${defaultVersion}/billings/upgrade-options`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        getUpgradePreview: async (targetPlanKey) => {
            const endpoint = `${url}/${defaultVersion}/billings/upgrade-preview/${targetPlanKey}`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        upgradePlan: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/billings/upgrade`;
            const response = await httpClient.post(endpoint, { payload });
            return response.data;
        },
        resubscribeCheckoutSession: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/billings/resubscribe-checkout-session`;
            const response = await httpClient.post(endpoint, { payload });
            return response.data;
        },
        submitRevocation: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/billings/revocation-request`;
            const response = await httpClient.post(endpoint, { payload });
            return response.data;
        },
        submitPauseRequest: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/billings/pause-request`;
            const response = await httpClient.post(endpoint, { payload });
            return response.data;
        },
    };
};
exports.default = billing;
